import { render, staticRenderFns } from "./userShowDetail.vue?vue&type=template&id=440da1fd&scoped=true&"
import script from "./userShowDetail.vue?vue&type=script&lang=js&"
export * from "./userShowDetail.vue?vue&type=script&lang=js&"
import style0 from "./userShowDetail.vue?vue&type=style&index=0&id=440da1fd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440da1fd",
  null
  
)

export default component.exports